import { IChatMessage } from '../../../model/chatmessage';
import { INormalizedObjects, NormalizedObjectsFactory } from '../../../common/interfaces/INormalizedObject';

export interface IState {
  newMessageReceived: boolean,
  chatmessages: INormalizedObjects<IChatMessage[]>;
  //lastMessage: { [sub: string]: Timestamp };
  unreadcount: {
    [key: string]: {
      count: number,
      date: Date
    }
  }
}

export const DefaultState = (): IState => ({
  newMessageReceived: false,
  chatmessages: NormalizedObjectsFactory(),
  //lastMessage: {},
  unreadcount: {}
})
